import { render, staticRenderFns } from "./videoUploadUgcBtn.vue?vue&type=template&id=68dc59f1&scoped=true"
import script from "./videoUploadUgcBtn.vue?vue&type=script&lang=js"
export * from "./videoUploadUgcBtn.vue?vue&type=script&lang=js"
import style0 from "./videoUploadUgcBtn.vue?vue&type=style&index=0&id=68dc59f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc59f1",
  null
  
)

export default component.exports